/**
 * Profile Screen
 * Allows users to view and edit their profile, change password, and logout
 */

import React, { useEffect } from 'react';
import { View } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useThemeColors } from '../theme';
import { WebContainer } from '../components/ui/WebContainer';
import { useUserPreferencesStore } from '../store/userPreferencesStore';
import { selectFetchProfile } from '../store/userPreferencesSelectors';
import {
  ProfileInfoSection,
  SubscriptionSection,
  CoursesSection,
  AppearanceSection,
  LanguageSection,
  AudioSpeechSection,
  AccountSection,
  PrivacyLegalSection,
  SupportSection,
} from '../components/profile';

export function ProfileScreen() {
  const { top: paddingTop, bottom: bottomInset } = useSafeAreaInsets();
  const theme = useThemeColors();

  const fetchProfile = useUserPreferencesStore(selectFetchProfile);

  // Fetch preferences on mount
  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return (
    <View style={{ flex: 1, backgroundColor: theme.background, paddingTop }}>
      {/* paddingBottom clears the bottom tab bar (~49pt) + home-indicator inset
          so the last section (SupportSection's dev-tools switches) can scroll
          fully above the tab bar — otherwise they sit under it and taps land on
          the tab bar instead of the switch. */}
      <KeyboardAwareScrollView testID="profile-screen" style={{ flex: 1 }} contentContainerStyle={{ paddingBottom: bottomInset + 72 }} bottomOffset={20} keyboardShouldPersistTaps="handled">
        <WebContainer variant="page">
          <ProfileInfoSection />
          <SubscriptionSection />
          <CoursesSection />
          <AppearanceSection />
          <LanguageSection />
          <AudioSpeechSection />
          <AccountSection />
          <PrivacyLegalSection />
          <SupportSection />
        </WebContainer>
      </KeyboardAwareScrollView>
    </View>
  );
}
